module.exports = __webpack_public_path__ + "static/media/69.64535dd9.jpg";